const sounds = {
    'message-in': new Audio('/sounds/notification-message-in-chat.mp3'),
    'notification': new Audio('/sounds/notification-message-out-chat.mp3'),
    'message-sent': new Audio('/sounds/send-message.mp3'),
}

// Браузер блокирует audio.play() без жеста пользователя.
// При первом клике "прогреваем" все треки нулевым воспроизведением,
// чтобы последующие вызовы проходили без блокировки.
let _unlocked = false

const _unlock = () => {
    if (_unlocked) return
    _unlocked = true

    Object.values(sounds).forEach(audio => {
        audio.muted = true
        audio.play()
            .then(() => { audio.pause(); audio.currentTime = 0; audio.muted = false })
            .catch(() => { audio.muted = false })
    })

    document.removeEventListener('click', _unlock)
    document.removeEventListener('keydown', _unlock)
}

document.addEventListener('click', _unlock)
document.addEventListener('keydown', _unlock)

export function playSound(name) {
    const audio = sounds[name]
    if (!audio) return
    audio.currentTime = 0
    audio.play().catch(() => {})
}
